export class Desperado {
	defaultOptions() {
		return {
			show: false,
			idCardType: {
				idCard: "id_card",
				passport: "passport",
				permit: "res_permit",
			},
			idCardValid: {
				notChecked: "not_checked",
				valid: "valid",
				invalid: "invalid",
			},
			desperadoTypes : {},
			private: {
				blockAuthorityAjax: false,
				fillingDesperado: false,
				loadingIdCardValidity: false,
				authLastFillTime: 0,
			},
			isWrongDoing: false,
		};
	}
	
	constructor(isWrongDoing) {
		var options = $('#js-opts').data('desperado');
		this.$options = $.extend({}, this.defaultOptions(), options || {});
		this.$options.isWrongDoing = isWrongDoing;
		
		this.handleButtons();
		if ( ! this.$options.show ) {
			this.buttonDesperadoActive();
		}
	}

	//=====================================================================
	// Public
	//=====================================================================

	lockAuthoritySelect (lock) {
		this.$options.private.blockAuthorityAjax = lock;
	}

	lockDesperado (lock) {
		this.$options.private.fillingDesperado = lock;
	}

	//=====================================================================
	// UI
	//=====================================================================

	desperadoTypeChanged ($li) {
		var value = $li.data('value'),
			$input = $($li.data('inputSelector')),
			$panel = $li.closest('.panel-body');

		$input.val(value).trigger('change');

		if (value === 'unknown') {
			$panel.find('h4.address-header-company').addClass('hidden');
			$panel.find('h4.address-header-person').addClass('hidden');
			$panel.find('.row.address').addClass('hidden');
		} else if (value === 'company') {
			$panel.find('h4.address-header-company').removeClass('hidden');
			$panel.find('h4.address-header-person').addClass('hidden');
			$panel.find('.row.address').removeClass('hidden');
		} else {
			$panel.find('h4.address-header-company').addClass('hidden');
			$panel.find('h4.address-header-person').removeClass('hidden');
			$panel.find('.row.address').removeClass('hidden');
		}
	}

	addDesperado ($button) {
		var app = this,
			$addrController = window.$addressAutocomplete,
			type = $button.data('type'),
			tpl = $('#js-desperado-template').html(),
			title = $Lang.wrongDoings.desperado.type[type],
			$list = $('#desperados-list'),
			key = getNextKey($list);

		tpl = tpl.replace(/\{\{type\}\}/g, type);
		tpl = tpl.replace(/\{\{title\}\}/g, title);
		tpl = tpl.replace(/\{\{key\}\}/g, key);

		$list.append(tpl);

		var $el = $list.find('#desperado_'+key);
		$el.find('.tooltips').tooltip();
		$addrController.initWhisperersBlock($el);
		$el.find('select[data-source-tpl]').each(function (i, el) {
			var $select = $(el);
			$select.data('source', $select.data('sourceTpl'));
			window.$whisperers.initSelect($select, null);
		});
		
		app.buttonDesperadoActive();
		$customs.initBootstrapFeatures($el);

		return $el;
	}

	confirmDesperadoRemoval ($panel, $desperadoBlock, type) {
		var app = this,
			lang = $Lang.wrongDoings.desperado;

		bootbox.confirm({
			'title' : lang.removeDesperadoTitle,
			'message' : lang.removeDesperadoConfirm,
			'callback' : function (result) {
				if (result)
				{
					if ($panel) {
						$panel.remove();
					}
					
					if (window.$indians) {
						$indians.setWrongDoingStateByIndians();
						$indians.clearSolutionFinish();
					}
					
					app.buttonDesperadoActive();
					if ($desperadoBlock)
					{
						app.changeDesperadoTypeFinish($desperadoBlock, type)
					}
				}
			}
		});
	}

	buttonDesperadoActive () {
		var $select = $('.wd-indians #state'),
			state = window.$Common.states,
			isShow = this.$options.show;
		if ($('.wd-desperado.type-a_desperado').length > 0)
		{
			$('#add-desperado-desperado').attr('disabled', 'disabled');
			$.each([$('#add-indian-indian'), $('#add-indian-slozenka')], function (i, $button) {
				$button.removeAttr('disabled');
				$button.parent().tooltip('destroy');
			});

			if (!isShow && ($select.val() == state.ST_NEVYRESENO)) {
				$select.removeAttr('disabled');
			}
			$select.parent().tooltip('destroy');
		}
		else
		{
			$('#add-desperado-desperado').removeAttr('disabled');
			$.each([$('#add-indian-indian'), $('#add-indian-slozenka')], function (i, $button) {
				$button.attr('disabled', 'disabled');
				$button.parent().tooltip();
			});
			$select.attr('disabled', 'disabled');
			$select.parent().tooltip();
		}
	}

	changeDesperadoType ($button) {
		var app = this,
			$desperadoBlock = $button.closest('.wd-desperado'),
			newType = $button.data('type');

		if ($desperadoBlock.hasClass('type-a_desperado') && app.$options.isWrongDoing)
		{
			this.confirmDesperadoRemoval(null, $desperadoBlock, newType);
		}
		else
		{
			this.changeDesperadoTypeFinish($desperadoBlock, newType);
		}
	}

	changeDesperadoTypeFinish ($desperadoBlock, newType) {
		var key = $desperadoBlock.data('key');

		$desperadoBlock.find('input[name="desperados['+key+'][type]"]').val(newType).trigger('change');

		var block = $desperadoBlock.get(0);
		if (block) {
			block.className = block.className.replace(/\s*(type-[^\s"']*)/, " type-" + newType);
		}

		$desperadoBlock.find('.js-title').text($Lang.wrongDoings.desperado.type[newType]);

		this.buttonDesperadoActive();
	}

	formatIco ($input) {
		var value = $input.val(),
			originalValue = value,
			leadingZerosCnt = 8 - value.length;
		while (leadingZerosCnt-- > 0) value = '0' + value;
		if (value !== originalValue) {
			$input.val(value).trigger('change');
		}
	}
	
	//=====================================================================
	// Authorities
	//=====================================================================

	getSelectOptions ($select) {
		var data = {};
		$select.find('option').each( function (i, el) {
			data[$(el).val()] = $(el).text();
		});
		return data;
	}

	findAuthority ($input, zipObject) {
		if (this.$options.private.blockAuthorityAjax) {
			return;
		}

		var app = this,
			town = null,
			zip = null,
			country = null,
			key = $input.data('authoritySelect'),
			$authSelect = $("#desperado-Authority-" + key),
			url = $authSelect.data('load');

		if (null == zipObject) {
			town = $('#desperado-Town-'+key).val();
			zip = $('#desperado-Zip-'+key).val();
			country = $('#desperado-Country-'+key).val();
		}

		$.ajax({
			url: url,
			dataType: 'json',
			data: {
				c : town,
				z : zip,
				r : country,
				i : zipObject ? zipObject.id : null,
			},
			method: 'post',
			success: function (response) {
				var now = Date.now();
				if ((now - app.$options.private.authLastFillTime) > 2000) {
					$authSelect.empty();
				}

				var currentData = app.getSelectOptions($authSelect),
					newData = [];
				if (Object.keys(currentData).length === 0) {
					newData = response;
				} else {
					$.each(response, function (i, d) {
						if (!(d.id in currentData) || (d.id === "")) {
							newData.push({ 'id': d.id, 'text': d.text });
							if (d.id === "") {
								delete currentData[""];
							}
						}
					});
					for (var id in currentData) {
						newData.push({ 'id': id, 'text': currentData[id] });
					}
				}

				var selectedId = app.findAuthSelectedId(newData);

				$authSelect.empty();
				$authSelect.select2({ data: newData });
				$authSelect.val(selectedId).trigger('change');

				app.$options.private.authLastFillTime = now;
			},
			error: function (e) {
				console.error(e);
			},
		});
	}

	findAuthSelectedId (values) {
		var relevantIds = [];
		for (var i in values) {
			if (( values[i].id !== "" ) && ( ! values[i].text.includes("CIZINEC") )) {
				relevantIds.push(values[i].id);
			}
		}
		if (relevantIds.length === 1) {
			return relevantIds[0];
		}
		return "";
	}

	//=====================================================================
	// Returning desperados
	//=====================================================================

	findDesperado ($input) {
		if ( ! this.$options.private.fillingDesperado ) {
			var app = this,
				name = $input.attr('name'),
				matches = ($input.val() ? name.match(/desperados\[(\d+)\]\[(.*)\]/) : null);

			if (matches && (2 in matches) && matches[2]) {
				var key = matches[1],
					type = [],
					value = {};
				
				switch (matches[2]) {
					case "card_number":
						var cardType = $('#desperado-identification-' + key).val();
						switch (cardType) {
							case "id_card":
								type = ["id_card_number"];
								value = { id_card_number: $input.val() };
								break;
							case "passport":
								type = ["passport_number"];
								value = { passport_number: $input.val() };
								break;
							case "res_permit":
								type = ["residence_permit"];
								value = { residence_permit: $input.val() };
								break;
							default:
								break;
						}
						break;
					
					case "personal_id":
						type = ["personal_id"];
						value = { personal_id: $input.val() };
						break;
					
					case "first_name":
					case "last_name":
					case "birth_date":
						const firstName = $('#desperado-firstName-' + key).val(),
							lastName = $('#desperado-lastName-' + key).val(),
							birthDate = $('#desperado-birthDate-' + key).val();
						
						if (firstName && lastName && birthDate) {
							type = ["first_name", "last_name", "birth_date"];
							value = {
								first_name: firstName,
								last_name: lastName,
								birth_date: birthDate
							}
						} else {
							return
						}
						break;
					
					default:
						return
				}

				$.ajax({
					url: route('desperados.find', {}),
					dataType: 'json',
					data: {
						t: type,
						v: value,
					},
					method: 'post',
					success: function (response) {
						if (response
							&& ('message' in response)
							&& ('data' in response)) {
							bootbox.confirm({
								message: response.message,
								buttons: {
									confirm: {
										label: 'Ano',
										className: 'btn-success'
									},
									cancel: {
										label: 'Ne',
										className: 'btn-danger'
									}
								},
								callback: function (result) {
									if (result) {
										app.fillDesperado(key, response.data, response.previousRecords);
									}
								}
							});
						}
					},
				});
			}
		}
	}

	fillDesperado(key, data, previousRecords) {
		this.$options.private.fillingDesperado = true;
		
		if (data.id_card_number) {
			data.identification = 'id_card';
			data.card_number = data.id_card_number;
			delete data.id_card_number;
		} else if (data.passport_number) {
			data.identification = 'passport';
			data.card_number = data.passport_number;
			delete data.passport_number;
		} else if (data.residence_permit) {
			data.identification = 'res_permit';
			data.card_number = data.residence_permit;
			delete data.residence_permit;
		}

		$.each(data, function (attr, val) {
			if (val) {
				$("[name=\"desperados[" + key + "][" + attr + "]\"]").val(val).change();
			}

			var $select = $("select[name=\"desperados["+key+"]["+attr+"]\"]");
			if ($select.length > 0) {
				if (val && attr == 'identification') {
					$select.find('option[value="' + val + '"]').prop('selected', true);
					$select.trigger('change');
				} else {
					$select.find('option').remove();
					if (val) {
						$select.append($('<option value="' + val + '" selected>' + val + '</option>'));
					}
					$select.trigger('change');
				}
			}
		});

		$("[name=\"desperados[" + key + "][original_id]\"]").val(data.original_id ? data.original_id : data.id);
		
		// fill previous records
		if ($('#desperado_' + key + ' .previous-records')) {
			$('#desperado_' + key + ' .previous-records').remove();
		}
		$('#desperado_' + key + ' .panel-body').after(previousRecords);

		this.$options.private.fillingDesperado = false;
	}

	//=====================================================================
	// ID Card
	//=====================================================================

	processIdCardScan (type, desperadoData) {
		var app = this,
			desperadoTypes = $Lang.wrongDoings.desperado.type,
			dialogTitle = "Načten průkaz: " + $Lang.wrongDoings.desperado.identification[type],
			birthDate = desperadoData.birthDate,
			validTypes = app.$options.idCardValid,
			validText = (desperadoData.validity.valid
				? "Platný do: <strong>" + desperadoData.validity.date + "</strong>"
				: "<span class='danger-invalid-id'><strong>Neplatný průkaz</strong>, konec platnosti: <strong>"
				+ desperadoData.validity.date + "</strong></span>"),
			dialogText = "<p>Data z průkazu:<br>"
				+ "Číslo: <strong>" + desperadoData.id + "</strong><br>"
				+ "Datum narození: <strong>" + desperadoData.birthDate + "</strong><br>"
				+ validText + "<br>"
				+ "Platnost dle MVČR: <span id='card-valid-mvcr'><i>Načítám...</i></span></p>"
				+ "<p>Načíst data k:</p>",
			options = {
				storno: {
					label: $Lang.common.cancel,
					className: 'btn-danger pull-left',
					callback: function(){
						//console.log('canceled');
					}
				},
			};

		for (var desperadoType in desperadoTypes) {
			options[desperadoType] = {
				label: $Lang.wrongDoings.desperado.type[desperadoType],
				className: 'btn-info ' + desperadoType,
				callback: function (e) {
					var valid = validTypes.notChecked,
						mvcrValid = $('#card-valid-mvcr').data('valid');
					if ((mvcrValid == validTypes.valid) && desperadoData.validity.valid) {
						valid = validTypes.valid;
					} else if ((mvcrValid == validTypes.invalid) || !desperadoData.validity.valid) {
						valid = validTypes.invalid;
					}
					app.fillCardScanData(
						e.target.dataset.bbHandler,
						desperadoData.id,
						birthDate,
						type,
						valid
					);
				},
			};
		}

		bootbox.dialog({
			title: dialogTitle,
			message: dialogText,
			inputType: 'radio',
			buttons: options,
		});

		app.checkIdCardValidity(desperadoData.id, type, "#card-valid-mvcr", null);
	}

	fillCardScanData (type, opId, birthDate, cardType, valid) {

		var app = this,
			$desperadoPanel = $('#desperados-list .panel.wd-desperado.type-' + type);
		if ($desperadoPanel.length === 0) {
			var $button = $('button.add-desperado[data-type='+type+']');
			$desperadoPanel = app.addDesperado($button);
		}

		$desperadoPanel.find('[id^=desperado-cardNumber-]').val(opId);
		$desperadoPanel.find('[id^=desperado-birthDate-]').val(birthDate);
		$desperadoPanel.find('[id^=desperado-identification-]').val(cardType).trigger('change');
		//Either valid or invalid
		app.setIdCardValidityInputValue($desperadoPanel.find('[id^=desperado-cardValid-]'), valid ? valid : "not_checked");
	}

	checkIdCardValidity (id, type, resultSpanId, $panel) {
		var app = this,
			cardTypes = app.$options.idCardType,
			url = route('desperados.validateId', {}),
			queryCardType = '0';

		if (!app.$options.private.loadingIdCardValidity) {
			app.$options.private.loadingIdCardValidity = true;

			if (type === cardTypes.passport) {
				queryCardType = '4';
			}

			$.ajax({
				url: url,
				method: 'post',
				dataType: 'json',
				data: {
					id: id,
					type: queryCardType,
				},
				success: function (response) {
					app.setIdCardValidity(
						(response && ('valid' in response) && response.valid),
						resultSpanId,
						$panel);
					app.$options.private.loadingIdCardValidity = false;
				},
				error: function (e) {
					if (resultSpanId) {
						$(resultSpanId).html("Ověření se nezdařilo");
					} else {
						bootbox.alert('Ověření se nezdařilo');
					}
					app.$options.private.loadingIdCardValidity = false;
				},
			});
		}
	}

	checkIdCardValidityButton ($button) {
		var app = this,
			$desperadoPanel = $button.closest('div.panel.wd-desperado'),
			id = $desperadoPanel.find('[id^=desperado-cardNumber-]').val(),
			type = $desperadoPanel.find('[id^=desperado-identification-]').val();

		app.checkIdCardValidity(id, type, null, $desperadoPanel);
	}

	setIdCardValidity (valid, resultSpanId, $desperadoPanel) {
		var validTypes = this.$options.idCardValid,
			resultValue = valid ? validTypes.valid : validTypes.invalid;
		if ($desperadoPanel != null) {
			this.setIdCardValidityInputValue($desperadoPanel.find('[id^=desperado-cardValid-]'), resultValue);
		}

		var text = valid ? "Není evidováno" : "Doklad evidován jako neplatný";
		if (resultSpanId) {
			var $resultSpan = $(resultSpanId);

			$resultSpan.addClass(resultValue);
			$resultSpan.data('valid', resultValue);
			$resultSpan.html(text);
		} else {
			bootbox.alert('Ověření: ' + text);
		}
	}
	setIdCardValidityInputValue ($input, result) {
		var $wrapper = $input.closest('.validation-wrapper');
		$input.val(result).trigger('change');
		$wrapper.removeClass('id-valid');
		$wrapper.removeClass('id-invalid');
		$wrapper.removeClass('id-not_checked');
		$wrapper.addClass('id-' + result);
	}

	//=====================================================================
	//=====================================================================

	/**
	 * HANDLE BUTTONS
	 */
	handleButtons() {
		var app = this,
			$document = $(document);

		if (!app.$options.show) {
			//UI
			$document.on('click', '.company-person-tabs > li', function () {
				app.desperadoTypeChanged($(this));
			});
			$document.on('click', '.add-desperado', function (e) {
				e.preventDefault();
				app.addDesperado($(this));
			});
			$document.on('click', '.wd-desperado a.js-change-type', function (e) {
				e.preventDefault();
				app.changeDesperadoType($(this));
			});
			$document.on('change', '.js-format-ico', function () {
				app.formatIco($(this));
			});

			//Authorities
			$document.on('change', '[data-authority-select]', function () {
				app.findAuthority($(this), null);
			});
			
			//Returning desperados
			$document.on('change', '.js-find-desperado', function () {
				app.findDesperado($(this));
			});
			
			//ID Card
			$document.on('opScanEvent', function (e) {
				app.processIdCardScan(app.$options.idCardType.idCard, e.detail);
			});
			$document.on('passportScanEvent', function (e) {
				app.processIdCardScan(app.$options.idCardType.passport, e.detail);
			});
			$document.on('rpScanEvent', function (e) {
				app.processIdCardScan(app.$options.idCardType.permit, e.detail);
			});
			$document.on('click', '.id-card-check-valid', function () {
				app.checkIdCardValidityButton($(this));
			});

		}
	}
}

